var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6169 8.4082V39.7988C33.6169 40.4716 33.048 41 32.3239 41H1.29296C0.568814 41 0 40.4716 0 39.7988V1.20117C0 0.528436 0.568814 0 1.29296 0H21.9802L24.5662 4.2041L27.1521 6.00586L33.6169 8.4082Z",
    fill: "#E3F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5644 4.2041L21.9785 0H16.8066V41H32.3221C33.0463 41 33.6151 40.4716 33.6151 39.7988V8.4082L27.1503 6.00586L24.5644 4.2041Z",
    fill: "#C7E9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0979 7.44719L22.7543 0.240154C22.5216 0.0960137 22.263 0 21.9785 0V7.20703C21.9785 7.8704 22.5574 8.4082 23.2715 8.4082H33.6151C33.6151 8.02391 33.4341 7.66348 33.0979 7.44719Z",
    fill: "#84D0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.b16b5aefc576762797938b688036c6e0.svg";
export { ForwardRef as ReactComponent };